// CardSection.js
import React from 'react';
import {
	CardElement,
//  injectStripe,
} from 'react-stripe-elements';
/*
const handleBlur = () => {
  console.log('[blur]');
};
const handleChange = (change) => {
  console.log('[change]', change);
};
const handleClick = () => {
  console.log('[click]');
};
const handleFocus = () => {
  console.log('[focus]');
};
const handleReady = () => {
  console.log('[ready]');
};

const createOptions = (fontSize, padding) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
        padding,
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};
*/
class CardSection extends React.Component {
  render() {
    return (
      <div>

      <CardElement style={{base: {fontSize: '15px'}}} />


        </div>
    );
  }
}

export default CardSection;
